<template>
    <div class="detail-info-group">
        <div
            key="open-house"
            v-if="info.listingStatus != 'Sold' && openHouse && openHouse.length"
            class="key-info open-house"
        >
            <h2 class="detail-title">{{ $t('md-detail-info.openHouse') }}</h2>
            <p
                class="detail-content"
                v-for="(item, index) in openHouse"
                :key="index"
            >
                <span class="date"><i class="iconfont icon-calendar_05"></i>{{ item.openHouseSchedules }}</span>
                <span class="appointment" v-if="item.appointment">{{ item.appointmentRequiredYN }}</span>
                <span class="broker" v-if="item.broker">{{ item.brokerRequiredYN }}</span>
            </p>
        </div>
        <slot></slot>
        <div
            key="on-site"
            v-if="showUpdated && showPropUpdate"
            class="key-info on-site"
            :class="{
                [soldFlag]: true,
                last: !openReadMore && !propertyDes && !firstGroup
            }"
        >
            <p class="detail-title" v-if="showUpdateAndDay">
                {{ $t('md-detail-info.updated') }}
            </p>
            <p class="detail-content">
                <span class="day-site" v-if="showUpdateAndDay">{{
                    updatedTime
                }}</span>
                <span class="tiny-site">
                    <only-client>{{ createTime() }}</only-client>
                </span>
            </p>
        </div>

        <div
            key="key-info"
            class="key-info"
            v-if="firstGroup"
            :class="{ last: !openReadMore && !propertyDes }"
        >
            <h2 class="detail-title">
                {{ firstGroup.nameText || firstGroup.name }}
            </h2>
            <div
                class="content"
                :class="[firstRowClass, isMobileSize ? 'mobile' : '']"
            >
                <p
                    v-for="(field, index) in firstGroup.fields"
                    :key="index"
                    class="info-content"
                >
                    <span class="info-title">{{ field.name }}</span>
                    <span class="info-data" v-html="field.value"></span>
                </p>
            </div>
        </div>

        <div
            key="key-info1"
            class="key-info"
            v-if="propertyDes"
            :class="{ last: !openReadMore }"
        >
            <p class="detail-title">
                {{ $t('md-detail-info.propertyDescription') }}
            </p>
            <div class="info-des">
                <div class="info-content read-more-content">
                    <span
                        ref="infoData"
                        class="info-data"
                        :class="{
                            'max-height': showPropertyMore && !propertyExpand
                        }"
                        v-html="propertyDes"
                    ></span>
                    <template v-if="showPropertyMore && propertyOverflow">
                        <span
                            class="property-read-more"
                            @click="propertyExpand = !propertyExpand"
                        >
                            <span>{{
                                propertyExpand
                                    ? $t('md-detail-info.readLessInfo')
                                    : $t('md-detail-info.readMoreInfo')
                            }}</span>
                            <i
                                class="iconfont icon-angle"
                                :class="{ expand: propertyExpand }"
                            ></i>
                        </span>
                    </template>
                </div>
            </div>
        </div>

        <div
            v-for="(group, index) in otherGroup"
            :key="index"
            v-show="openReadMore && group.fields.length > 0"
            class="key-info"
        >
            <h2 class="detail-title">{{ group.nameText || group.name }}</h2>
            <div
                class="content"
                :class="[otherRowClass, isMobileSize ? 'mobile' : '']"
            >
                <p
                    v-for="(field, index) in group.fields"
                    :key="index"
                    class="info-content"
                >
                    <template v-if="field.id == BUILDING_FIELDID">
                        <span class="info-title">{{
                            $t('md-detail-info.buildings')
                        }}</span>
                        <span class="info-data">
                            <a
                                :href="field.value"
                                target="_self"
                                rel="noopener noreferrer"
                            >{{ field.extraArg }}</a>
                        </span>
                    </template>
                    <template v-else>
                        <span class="info-title">{{ field.name }}</span>
                        <span class="info-data" v-html="field.value"></span>
                    </template>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import { formats, dateFormat } from '@/common/format';
import {
    KeyDetails,
    Location,
    Interior,
    Exterior,
    Building,
    School,
    Rooms,
    Others,
    MultiUnitInfo
} from './key-value.js';
import util from '../../common/util.js';
import { INTERCEPT_MLS } from '@/common/customize.js';
const BUILDING_FIELDID = 199;
export default {
    i18next: {
        ns: 'md-detail-info',
        // translationResourcesLoaded() {
        //     this.$emit('refresh-parent');
        // }
    },
    inject: ['showSoldPrice', 'createTime'],
    data: function() {
        return {
            propertyOverflow: false,
            propertyExpand: true,
            BUILDING_FIELDID,
            updatedTime: ''
        };
    },
    props: {
        openReadMore: {
            default: true,
            type: Boolean
        },
        firstRowClass: {
            type: String,
            default: 'two-columns'
        },
        otherRowClass: {
            type: String,
            default: 'single-column'
        },
        showPropUpdate: {
            type: Boolean,
            default: true
        },
        showPropertyMore: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.$nextTick(() => {
            let propertyDetail = this.$refs.infoData;
            if (propertyDetail && this.showPropertyMore) {
                const maxHeight = 120;
                let h = propertyDetail.offsetHeight;
                if (h && h > maxHeight) {
                    this.propertyOverflow = true;
                } else {
                    this.propertyOverflow = false;
                }
                this.propertyExpand = false;
            }
        });
        if (this.info.updateTimeLong) {
            this.updatedTime = dateFormat(
                'MM/dd/yyyy hh:mm p',
                new Date(this.info.updateTimeLong),
                this.$pinia
            );
        }
    },
    methods: {
        getPairValues(pairs) {
            let values = [];
            for (let name in pairs) {
                let valueExp = pairs[name];
                let value;
                if (typeof valueExp == 'string') {
                    value = this.info[valueExp];
                }
                if (typeof valueExp == 'function') {
                    value = valueExp(this.info);
                }
                if (value != '' && value != undefined && value != -1) {
                    values.push({
                        name: this.$t(`md-detail-info.${name}`),
                        value: value
                    }); 
                }
            }
            return values;
        }
    },
    computed: {
        ...rootMapState(usePageStore, {
            'page': store => store.page || {},
            'house': store => store.page?.house || {},
            'currencySymbol': store => store.currency?.symbol
        }),
        ...mapState({
            'listingGroups': store => store.listingDetail.listingGroups,
            'mlsOrg': store => store.listingDetail.info.mlsOrg,
            'info': store => store.listingDetail.info || {}
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        detailDes() {
            if (this.info.detailsDescribe) {
                return this.info.detailsDescribe.replace('\n', '<br>');
            } else {
                return '';
            }
        },
        // updatedTime() {
        //     if (this.info.updateTimeLong) {
        //         return dateFormat(
        //             'MM/dd/yyyy hh:mm p',
        //             new Date(this.info.updateTimeLong),
        //             this.$pinia
        //         );
        //     } else {
        //         return '';
        //     }
        // },
        firstGroup() {
            let firstGroup = null;
            let listingGroups = util.deepClone(this.listingGroups);
            if (listingGroups?.length > 0) {
                const customFields = {
                    'mls listing id': {
                        mls: INTERCEPT_MLS.listingId,
                        value: this.$t('md-detail-info.mlsListingId')
                    }
                };
                firstGroup = listingGroups[0];
                firstGroup.fields.forEach(field => {
                    let name = field.name.toLowerCase();
                    if (name == 'sold date' || name == 'leased date') {
                        if (!isNaN(field.value)) {
                            field.value = dateFormat(
                                'MM/dd/yyyy',
                                new Date(+field.value),
                                this.$pinia
                            );
                        }
                    }
                    if (name == 'sold price') {
                        if (this.info.listingStatus != 'Sold') {
                            field.value = '-';
                            return;
                        }
                        if (
                            !this.house.showListingPrice &&
                            !this.showSoldPrice
                        ) {
                            field.value = 'Non-Disclosure';
                            return;
                        }
                        if (this.showSoldPrice) {
                            field.value = formats.currency({
                                value: this.info.soldPrice,
                                noSpace: true,
                                currencySymbol: this.currencySymbol
                            });
                        } else {
                            field.value = formats.currency({ value: this.info.price, noSpace: true, currencySymbol: this.currencySymbol });
                        }
                        if (this.info.nodisclosureDes != null) {
                            field.value =
                                '$ &#xfe61;&#xfe61;&#xfe61;&#xfe61;&#xfe61; ' +
                                (this.info.nodisclosureDes
                                    ? '(' + this.info.nodisclosureDes + ')'
                                    : ''); 
                        }
                    }
                    for (let key in customFields) {
                        let customField = customFields[key];
                        if (
                            key === name &&
                            customField.mls.includes(
                                util.getValueByPath(this.info, 'mlsOrg.id', 0)
                            )
                        ) {
                            field.name = customField.value;
                        }
                    }
                });
                if (
                    this.info.listingStatus != 'Sold' ||
                    (this.house.showListingPrice && !this.showSoldPrice)
                ) {
                    firstGroup.fields = firstGroup.fields.filter(
                        field => field.name.toLowerCase() != 'sold price'
                    );
                }
                if (this.info.pricePerSqft) {
                    firstGroup.fields = firstGroup.fields.filter(
                        field => field.name != 'Price per Sqft'
                    );
                }
            }
            return firstGroup;
        },
        otherGroup() {
            let otherGroup = [];
            let listingGroups = util.deepClone(this.listingGroups);
            if (listingGroups?.length > 0) {
                otherGroup = listingGroups.slice(1);
                otherGroup.forEach(group => {
                    if (group.fields) {
                        group.fields.forEach(field => {
                            if (
                                field.type == '1' &&
                                typeof field.value == 'string'
                            ) {
                                field.value = field.value.replace(/, */g, ', ');
                            }
                        });
                    }
                });
            }
            return otherGroup;
        },
        keydetails() {
            let values = this.getPairValues(KeyDetails);
            return values;
        },
        groups() {
            let groups = [
                {
                    title: this.$t('md-detail-info.location'),
                    items: this.getPairValues(Location)
                },
                {
                    title: this.$t('md-detail-info.interior'),
                    items: this.getPairValues(Interior)
                },
                {
                    title: this.$t('md-detail-info.exterior'),
                    items: this.getPairValues(Exterior)
                },
                {
                    title: this.$t('md-detail-info.building'),
                    items: this.getPairValues(Building)
                },
                {
                    title: this.$t('md-detail-info.schools'),
                    items: this.getPairValues(School)
                },
                {
                    title: this.$t('md-detail-info.rooms'),
                    items: this.getPairValues(Rooms)
                },
                {
                    title: this.$t('md-detail-info.others'),
                    items: this.getPairValues(Others)
                },
                {
                    title: this.$t('md-detail-info.multiUnitInfo'),
                    items: this.getPairValues(MultiUnitInfo)
                }
            ];
            return groups;
        },
        propertyDes() {
            return this.info.detailsDescribe;
        },
        showUpdated() {
            return (
                this.info.updateTimeLong != null ||
                this.info.createTimeLong != null ||
                this.info.chimeFirstInserted != null
            );
        },
        showUpdateAndDay({ info }) {
            //CHIME-21882
            return !INTERCEPT_MLS.hiddenUpdateTime.includes(
                util.getValueByPath(info, 'mlsOrg.id', 0)
            );
        },
        openHouse({ info, $t }) {
            // temp solution. Then the back end slowly migrates to this field
            if (info.openHouseSchedulesV2 && info.openHouseFlag) {
                return info.openHouseSchedulesV2.map(item => {
                    return {
                        ...item,
                        appointmentRequiredYN: item.appointment
                            ? $t('md-detail-info.byAppointmentOnly')
                            : '',
                        brokerRequiredYN: item.broker
                            ? $t('md-detail-info.byBrokerOnly')
                            : ''
                    };
                });
            }
            if (
                info.openHouseScheduleList &&
                info.openHouseScheduleList.length > 0 &&
                info.openHouseFlag
            ) {
                return this.info.openHouseScheduleList.map(v => ({ openHouseSchedules: v }));
            }
            return null;
        },
        soldFlag() {
            if (this.info.listingStatus == 'Sold') {
                return 'sold-detail';
            }
            return '';
        }
    }
};
</script>
<style lang="scss" src="./detail-info-group.scss"></style>
